import { render, staticRenderFns } from "./cheliangxinxi.vue?vue&type=template&id=10179510&scoped=true&"
import script from "./cheliangxinxi.vue?vue&type=script&lang=js&"
export * from "./cheliangxinxi.vue?vue&type=script&lang=js&"
import style0 from "./cheliangxinxi.vue?vue&type=style&index=0&id=10179510&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10179510",
  null
  
)

export default component.exports